// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3hTo7","unreadBadge":"styles_unreadBadge__3rPV9","modalContent":"styles_modalContent__dwbSU","modal":"styles_modal__ZZxHC"};